import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

export interface TokenData {
  type: string;
  id: number;
  email: string;
  manage_administrators: boolean;
  manage_settings: boolean;
  manage_users: boolean;
  manage_chat_rooms: boolean;
  manage_translations: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private jwtHelperService = new JwtHelperService();

  setToken(token: string): void {
    localStorage.setItem('access_token', token);
  }

  getToken(): string | null {
    return localStorage.getItem('access_token');
  }

  setRefreshToken(refreshToken: string): void {
    localStorage.setItem('refresh_token', refreshToken);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem('refresh_token');
  }

  removeTokens(): void {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
  }

  isTokenExpired(): boolean {
    const token = this.getToken();
    return token ? this.jwtHelperService.isTokenExpired(token) : true;
  }

  decodeToken(): TokenData | null {
    const token = this.getToken();

    if (token) {
      return this.jwtHelperService.decodeToken(token);
    }

    return null;
  }
}
